import _ from 'lodash';
import { useContext, useEffect, useMemo, useState } from 'react';
import { uniqueKey } from '../../../../global/common/keys';
import UiSaveButtons from '../../../../global/components/buttons/UiSaveButtons';
import UpDownLabel from '../../../../global/components/forms/elements/UpDownLabel';
import { gEnums } from '../../../../global/enums/globalEnums';
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper';
import WrapperVertCols from '../../../../global/wrappers/WrapperVertCols';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { _allowUpdate_local, seasonalUpdateTypes } from '../../cnr/reducers/reducerHelpers/seasonalDataHelpers';
import { CreateSportsSeasonContext } from '../CreateSeason';
import SeasonDetailsForm, { _seasonFormTypes } from './SeasonDetailsForm';
import { useCreateSportsSeason } from 'projectSpecific/sports/useHelpers/useCreateSeasonal';
import { useCreateSeasonData } from 'projectSpecific/sports/useHelpers/useCreateSeasonData';

const CreateSportsDetails = ({ subActionType }) => {

  const _asat = gEnums.availableSubActionTypes

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { details_info } = sportsSeason_state ?? {}
  const { playoffQualifyCounts: playoffQualifyCounts_sport, details } = details_info ?? {}

  // createSportsSeaonContext
  const createSportsSeasonContext = useContext(CreateSportsSeasonContext);
  const { createSportsSeason_handlers } = createSportsSeasonContext ?? {}

  const { update_seasonalData } = useCreateSeasonData()

  const { getCurrent, ammendSeasonalItem } = useCreateSportsSeason()
  const { sportsData_info, currentSeason_info, sportsSeason_selected, selectedItems } = getCurrent()
  const { sportPermissions } = sportsData_info ?? {}
  const { seasonals } = sportsSeason_selected ?? {}
  const { playoffQualifyCounts: playoffQualifyCounts_create } = seasonals ?? {}
  const { year } = selectedItems ?? {}
  const { latestSeason, sportsKey } = currentSeason_info ?? {}

  const allowUpdate = _allowUpdate_local && sportPermissions.any && sportPermissions?.details

  let _year;

  switch (subActionType) {
    case _asat.editSeasonDetails:
      _year = latestSeason
      break;
    default:
      _year = year
  }

  const [playoffQualifyCounts, setPlayoffQualifyCounts] = useState(playoffQualifyCounts_sport || playoffQualifyCounts_create)

  const handleUpdateSeasonal = () => {
    const cbu = () => { }
    const _details = {
      details,
      playoffQualifyCounts
    }
    const _opts_m = { _details }
    update_seasonalData({ _seasonalKey, updateType: seasonalUpdateTypes.details, opts: _opts_m, callback: cbu })
  }

  const handleUpDown_qualify = (propKey, value) => {
    const _playoffQualifyCounts = _.cloneDeep(playoffQualifyCounts)
    _playoffQualifyCounts[propKey] = value ? value : 0
    setPlayoffQualifyCounts(_playoffQualifyCounts)
    switch (subActionType) {
      case _asat.createSeason:
        ammendSeasonalItem({ key: 'playoffQualifyCounts', data: _playoffQualifyCounts })
        break;
      default:
        ammendSeasonalItem({ key: 'playoffQualifyCounts', data: _playoffQualifyCounts })
    }
  }

  const menu_qualify = useMemo(() => {
    const items = _.map(playoffQualifyCounts, (sl, slKey) => {
      return <UpDownLabel
        propKey={slKey}
        formData={playoffQualifyCounts}
        handleChange={handleUpDown_qualify}
        buttonSize={'tiny'} float={'left'} />
    })
    return <div>
      {items}
    </div>
  }, [playoffQualifyCounts])

  const create_form = (seasonFormType) => <SeasonDetailsForm
    key={uniqueKey('cs', 'season')}
    seasonFormType={seasonFormType}
    subActionType={subActionType}
  />

  const content_formYear = () => <Wrapper
    header={'Current Year'}
    content={create_form(_seasonFormTypes.currentYear)}
    wrapperType={wrapperTypes.padded}
  />

  const content_formStart = () => <Wrapper
    header={'Season Dates'}
    content={create_form(_seasonFormTypes.seasonStart)}
    wrapperType={wrapperTypes.padded}
  />

  const content_formCurrent = () => <Wrapper
    header={'Season Options'}
    content={create_form(_seasonFormTypes.currentSeason)}
    wrapperType={wrapperTypes.padded}
  />

  const content_qualifyCount = () => <Wrapper
    header={'Playoff Qualify Counts'}
    content={menu_qualify}
    wrapperType={wrapperTypes.padded}
  />

  const _cols = subActionType === _asat.editSeason ? 4 : 3

  const content_season = () => <WrapperVertCols mvc={_cols}>
    {subActionType === _asat.editSeason && content_formYear()}
    {content_formStart()}
    {content_qualifyCount()}
    {content_formCurrent()}
  </WrapperVertCols>

  const wrapper_season = () => <Wrapper
    header={'Details'}
    content={content_season()}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const wrapper = () => <Wrapper
    header={'Details'}
    content={content_season()}
    footer={<UiSaveButtons save={{ caption: 'Update Seasonal Details (' + _year + ')', oc: handleUpdateSeasonal, disabled: !_year, color: allowUpdate ? 'green' : 'teal' }} />}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  switch (subActionType) {
    case _asat.createSeason:
      return wrapper_season()
    default:
      return wrapper()
  }

}

export default CreateSportsDetails